import { CssBaseline, ThemeProvider } from '@mui/material';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import { useMuiTheme } from '@/hooks/use-mui-theme';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { prefixer } from 'stylis';

const rtlCache = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

const ltrCache = createCache({
  key: 'mui',
});

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme } = useMuiTheme();

  return (
    <CacheProvider value={theme.direction === 'rtl' ? rtlCache : ltrCache}>
      <ThemeProvider defaultMode="system" noSsr theme={theme}>
        <CssBaseline enableColorScheme enableCustomBackground />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};
